import { GET_CATEGORIES, UPDATE_CATEGORY } from 'admin/constants';
import { API_ENDPOINTS } from 'common/constants';

export function getCategories() {
	return async dispatch => {
		await dispatch({
			type: GET_CATEGORIES.START,
			url: API_ENDPOINTS.getCategories,
			method: 'GET',
			onSuccess: res => dispatch({ type: GET_CATEGORIES.SUCCESS, payload: { ...res.data } }),
			onFail: () => dispatch({ type: GET_CATEGORIES.FAIL }),
		});
	};
}

export function updateCategory(data) {
	return async dispatch => {
		try {
			dispatch({ type: UPDATE_CATEGORY.START });

			const result = await dispatch({
				type: UPDATE_CATEGORY.START,
				url: API_ENDPOINTS.updateCategory,
				secure: true,
				payload: data,
				onSuccess: res => dispatch({ type: UPDATE_CATEGORY.SUCCESS, payload: { ...res.data } }),
				onFail: () => dispatch({ type: UPDATE_CATEGORY.FAIL }),
			});

			return result;
		} catch (e) {
			dispatch({ type: UPDATE_CATEGORY.FAIL });
			return e;
		}
	};
}
